import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useRBAC } from "../context/rbac/RBACContext";

/**
 * RBAC guard. Parent should be inside AuthenticatedRoute (RBAC already loaded).
 * @param {{ scope: 'machine' | 'studio' }} props
 */
const AuthorizedRoute = ({ scope }) => {
	const location = useLocation();
	const { canAccessPage, loading } = useRBAC();

	if (loading) {
		return null;
	}

	if (!canAccessPage(location.pathname)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <Outlet />;
};

export default AuthorizedRoute;
